import Vue from 'vue';
import Component from 'vue-class-component';
import Snackbar from '@/shared/components/snackbar/snackbar.vue';
import PromptDialog from '@/shared/components/prompt-dialog/prompt-dialog.vue';
import Navigation from '@/shared/components/navigation-drawer/navigation-drawer.vue';

@Component({
    components: {Snackbar, PromptDialog, Navigation},
})
export default class App extends Vue {
    private get isNotLoginPage() {
        return this.$route.name != 'Login';
    }
}
